import React from "react";
import { assetIcons } from "../../../constants/assets";
import { useTheme } from "../../../providers/theme-provider";
import CtaButton from "../../buttons/cta-button/cta-button";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import useSmoothScroll from "../../../hooks/use-smooth-scroll";
import { fontSizes } from "../../../theme/font-sizes";

const NavbarLarge = ({ isScrolled }) => {
  const { colors, isDarkMode, toggleTheme } = useTheme();
  const { t } = useTranslation();

  const handleScroll = useSmoothScroll();

  // Animation variants for the navbar items
  const navItemVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  const navItems = [
    { label: t("navbar.navItems.home"), sectionId: "home" },
    { label: t("navbar.navItems.services"), sectionId: "services" },
    { label: t("navbar.navItems.testimonials"), sectionId: "testimonials" },
    { label: t("navbar.navItems.contact"), sectionId: "contact" },
  ];

  // Determine the appropriate image for the theme toggle button
  const themeToggleIcon = isDarkMode
    ? assetIcons.bulbDark
    : assetIcons.bulbLight;

  return (
    <motion.div
      className={`flex justify-between items-center gap-2 w-full transition-all duration-300 md:py-8 py-4`}
      style={{
        // backgroundColor: isScrolled ? colors.background : "transparent",
        opacity: 0.8,
        color: colors.textColor,
        maxWidth: isScrolled ? "95%" : "100%",
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div onClick={() => handleScroll("home")}>
        <img
          src="/logo.png"
          alt=""
          className="cursor-pointer lg:w-auto w-32"
          onClick={() => handleScroll("home")}
        />
      </div>

      <nav>
        <motion.ul
          className="flex lg:gap-8 gap-5 items-center"
          initial="hidden"
          animate="visible"
          // variants={{
          //   visible: { transition: { staggerChildren: 0.5 } },
          // }}
        >
          {navItems.map((item, index) => (
            <motion.li
              key={index}
              variants={navItemVariants}
              className="font-medium cursor-pointer relative group"
              style={{
                color: colors.textColor,
                transition: "color 0.1s ease",
                fontSize: fontSizes.navItem,
              }}
              onClick={() => handleScroll(item.sectionId)}
            >
              {item.label}
              <motion.div
                className="absolute left-0 bottom-0 h-[2px] w-full bg-current scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"
                style={{ backgroundColor: colors.redColor }}
              />
            </motion.li>
          ))}
        </motion.ul>
      </nav>

      <motion.div className="flex items-center gap-2">
        <div
          className="xl:p-4 p-3 rounded-sm cursor-pointer"
          style={{
            backgroundColor: colors.themeToggle,
          }}
          onClick={toggleTheme}
        >
          <img src={themeToggleIcon} alt="Theme Toggle" />
        </div>
        <CtaButton
          label={t("navbar.ctaButton")}
          onClick={() => handleScroll("contact")}
        />
      </motion.div>
    </motion.div>
  );
};

export default NavbarLarge;
